export default function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};



// WEBPACK FOOTER //
// ./src/utils/numberFormat.js